import React, { memo, FC } from "react";
import { Image } from "cloudinary-react";
import useBannerSelector from "./useBannerSelector";

const ImageBanner: FC = () => {
  const { displayedBanner } = useBannerSelector();

  if (displayedBanner) {
    return (
      <Image
        style={{ marginBottom: 10, marginTop: 60, borderRadius: 5 }}
        cloudName="ag-millworks"
        secure={true}
        publicId={displayedBanner}
      />
    );
  }

  return null;
};

export default memo(ImageBanner);
